var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M16.3125 8.99548C16.3125 10.9349 15.5421 12.7948 14.1707 14.1662C12.7994 15.5376 10.9394 16.308 9 16.308C7.0606 16.308 5.2006 15.5376 3.8293 14.1662C2.4579 12.7948 1.6875 10.9349 1.6875 8.99548C1.6875 7.05609 2.4579 5.19613 3.8293 3.82477C5.2006 2.45341 7.0606 1.68298 9 1.68298C10.9394 1.68298 12.7994 2.45341 14.1707 3.82477C15.5421 5.19613 16.3125 7.05609 16.3125 8.99548ZM0 8.99548C0 11.3824 0.948202 13.6716 2.636 15.3594C4.3239 17.0473 6.6131 17.9955 9 17.9955C11.3869 17.9955 13.6761 17.0473 15.364 15.3594C17.0518 13.6716 18 11.3824 18 8.99548C18 6.60853 17.0518 4.31935 15.364 2.63152C13.6761 0.943701 11.3869 -0.0045166 9 -0.0045166C6.6131 -0.0045166 4.3239 0.943701 2.636 2.63152C0.948202 4.31935 0 6.60853 0 8.99548ZM8.1562 4.21423V8.99548C8.1562 9.2767 8.2969 9.5404 8.5324 9.6986L11.9074 11.9486C12.2941 12.2088 12.818 12.1033 13.0781 11.7131C13.3383 11.3228 13.2328 10.8025 12.8426 10.5424L9.8438 8.54548V4.21423C9.8438 3.74666 9.4676 3.37048 9 3.37048C8.5324 3.37048 8.1562 3.74666 8.1562 4.21423Z",
          fill: "#2E2E2E",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }